import React from 'react'

const DebitCredit = ({ strokeColor = "black" }: { strokeColor: string }) => {
  return (
    <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3327 6.33399L1.66602 6.33398M4.84062 14.6673H15.1581C16.9114 14.6673 18.3327 13.1749 18.3327 11.334V4.66732C18.3327 2.82637 16.9114 1.33398 15.1581 1.33398H4.84062C3.08733 1.33398 1.66602 2.82637 1.66602 4.66732V11.334C1.66602 13.1749 3.08733 14.6673 4.84062 14.6673Z"
          stroke={strokeColor}
          strokeWidth="1.5"
        />
      </svg>
  )
}

export default DebitCredit
